import React from 'react';

function DocIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "27",
    height: "31",
    viewBox: "0 0 27 31"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#CBCBCB",
    fillRule: "nonzero",
    d: "M25.7 6.514c.364.376.649.819.84 1.302.217.475.336.987.35 1.508v19.738a1.62 1.62 0 01-.49 1.165 1.693 1.693 0 01-1.191.48H1.68a1.693 1.693 0 01-1.19-.48A1.62 1.62 0 010 29.062V1.648A1.62 1.62 0 01.489.481C.804.171 1.233-.002 1.68 0h15.687a4.12 4.12 0 011.54.342 4.08 4.08 0 011.33.822l5.463 5.35zm-7.772-4.18v6.442h6.583a1.86 1.86 0 00-.385-.702L18.64 2.71a1.925 1.925 0 00-.718-.377h.006zm6.722 26.175V10.97h-7.283a1.693 1.693 0 01-1.191-.48 1.62 1.62 0 01-.49-1.165V2.197H2.24v26.316h22.41v-.004z"
  }), React.createElement("g", {
    transform: "rotate(90 2.709 18.474)"
  }, React.createElement("rect", {
    width: "2.034",
    height: "15.924",
    fill: "#CBCBCB",
    fillRule: "nonzero",
    rx: "1"
  }), React.createElement("rect", {
    width: "1.017",
    height: "14.929",
    x: "0.508",
    y: "0.498",
    stroke: "#CBCBCB",
    rx: "0.5"
  })), React.createElement("g", {
    transform: "rotate(90 .718 20.464)"
  }, React.createElement("rect", {
    width: "2.034",
    height: "15.924",
    fill: "#CBCBCB",
    fillRule: "nonzero",
    rx: "1"
  }), React.createElement("rect", {
    width: "1.017",
    height: "14.929",
    x: "0.508",
    y: "0.498",
    stroke: "#CBCBCB",
    rx: "0.5"
  })), React.createElement("g", {
    transform: "rotate(90 -1.272 22.455)"
  }, React.createElement("rect", {
    width: "2.034",
    height: "15.924",
    fill: "#CBCBCB",
    fillRule: "nonzero",
    rx: "1"
  }), React.createElement("rect", {
    width: "1.017",
    height: "14.929",
    x: "0.508",
    y: "0.498",
    stroke: "#CBCBCB",
    rx: "0.5"
  }))));
}

export default DocIcon;